import { CircularProgress, Stack } from '@mui/material';

export function DefaultLoadingFallback() {
  return (
    <Stack alignItems="center" justifyContent="center" flexGrow={1}>
      <CircularProgress color="primary" />
    </Stack>
  );
}
